import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Image from '../../../components/AppImage';
import ZohoLogo from '../../../components/ZohoLogo';
import Tooltip from '../../../components/ui/Tooltip';
import AlertTypeBadge from './AlertTypeBadge';
import { getCandidateProfilePath } from '../../../lib/utils/candidateRoutes';

const ActivityRow = ({ activity }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const getInitials = (name) => {
    if (!name) return '?';
    const parts = name.trim().split(' ');
    if (parts.length >= 2) {
      return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
  };

  const handleViewProfile = () => {
    if (!activity?.candidateId) return;
    navigate(getCandidateProfilePath(activity.candidateId));
  };

  return (
    <tr
      className="group border-b border-border cursor-pointer"
      onClick={handleViewProfile}
    >
      <td className="px-4 py-4 transition-colors group-hover:bg-muted">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
            {activity?.avatar ? (
              <Image
                src={activity.avatar}
                alt={activity.avatarAlt}
                className="w-full h-full object-cover"
              />
            ) : (
              <div className="w-full h-full bg-primary text-primary-foreground flex items-center justify-center text-sm font-semibold">
                {getInitials(activity?.candidateName)}
              </div>
            )}
          </div>
          <div className="min-w-0 max-w-[250px]">
            <div className="flex items-center gap-2 flex-wrap">
              <p className="text-sm font-medium text-foreground truncate">
                {activity?.candidateName}
              </p>
              {activity?.isFromZoho && (
                <Tooltip content={t('candidates.fromZoho')} align="start" size="sm">
                  <span className="inline-flex items-center justify-center flex-shrink-0">
                    <ZohoLogo size={16} />
                  </span>
                </Tooltip>
              )}
            </div>
            <p className="text-sm text-muted-foreground break-words leading-snug">
              {activity?.currentRole}
            </p>
          </div>
        </div>
      </td>
      <td className="px-4 py-4 transition-colors group-hover:bg-muted">
        <p className="text-sm text-foreground line-clamp-2">
          {activity?.description}
        </p>
      </td>
      <td className="px-4 py-4 whitespace-nowrap transition-colors group-hover:bg-muted">
        <AlertTypeBadge
          label={activity?.alertTypeLabel}
          className={activity?.alertTypeClassName}
        />
      </td>
      <td className="px-4 py-4 whitespace-nowrap transition-colors group-hover:bg-muted">
        <p className="text-sm text-muted-foreground">
          {activity?.time}
        </p>
      </td>
    </tr>
  );
};

export default ActivityRow;
